module.exports = __webpack_public_path__ + "static/media/instructions.b0d8fbc7.mp4";